import { ref } from 'vue'

const pageTitleOverride = ref<string | null>(null)

export function usePageTitle() {
  return pageTitleOverride
}
